import React from 'react';
import { Icon, IconColor } from '../Icon';
import { SVGComponent } from '../Icon/types';

interface LinkWithIconProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  cypress?: string;
  stat?: string;
  icon?: SVGComponent;
  width?: number;
  height?: number;
  color?: IconColor;
  indent?: boolean;
  styles?: React.CSSProperties;
}

export const LinkWithIcon: React.FC<LinkWithIconProps> = ({
  cypress,
  stat,
  onClick,
  onKeyPress,
  role,
  tabIndex,
  href,
  icon,
  width,
  height,
  color,
  indent,
  styles,
  ...rest
}) => (
  <a
    data-cy={cypress}
    data-stat={stat}
    onKeyPress={onKeyPress}
    {...{ role, tabIndex, onClick, href, ...rest }}
    style={{ ...styles, cursor: 'pointer' }}
  >
    <Icon IconComponent={icon!} {...{ width, height, color, indent }} />
  </a>
);
